import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle2 } from 'lucide-react';
import { SITE_IMAGES } from '../../components/siteImages';
export function FamilyAdultBenefits() {
  return <section className="py-24 bg-off-white" data-id="element-1049">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1050">
        <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-1051">
          <div className="order-2 lg:order-1" data-id="element-1052">
            <div className="inline-flex items-center gap-2 bg-storm-red/10 text-storm-red px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wide mb-4" data-id="element-1053">
              For Adults
            </div>
            <h2 className="text-4xl md:text-5xl text-ink mb-6" data-id="element-1054">
              Benefits for Adults
            </h2>
            <p className="text-lg text-gray-warm mb-6" data-id="element-1055">
              Parents tell us family classes are the only workout they actually
              stick with — because it doesn't feel like a chore. You're building
              something with your kids, not just clocking gym hours.
            </p>
            <ul className="space-y-3 mb-8" data-id="element-1056">
              {['Full-body fitness: cardio, strength, flexibility, balance', 'Stress relief from a structured, screen-free hour', 'Skill-based progression that keeps you engaged long-term', 'Modeling healthy habits for your kids in the most direct way possible', 'Adult-friendly drills scaled to your fitness level — beginners welcome'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-1057">
                  <CheckCircle2 className="w-6 h-6 text-storm-red shrink-0 mt-0.5" data-id="element-1058" />
                  <span className="text-ink" data-id="element-1059">{item}</span>
                </li>)}
            </ul>
            <Link to="/karate-adult-classes" className="text-storm-red font-bold hover:underline inline-flex items-center gap-1" data-id="element-1060">
              Explore Adult Classes →
            </Link>
          </div>
          <div className="order-1 lg:order-2" data-id="element-1061">
            <img src={SITE_IMAGES.adultClasses} alt="Adults training at Storm Taekwondo" className="block rounded-2xl shadow-xl w-full object-cover aspect-[4/3]" data-id="element-1062" />
          </div>
        </div>
      </div>
    </section>;
}